import { travelConfig } from '@/define/magnet_travel'
import { AssistKeys } from '@/define/vkcode'
import i18n from '@/languages/i18n'
import { defaultTextureWidth } from '@/profiles/keyboard/keytexture/default'
import { DeviceManager } from '@/service/device'
import { BaseTabs } from '@/service/driver/action_set'
import { isElectron } from '@libs/utils/envUtils'

export const generateArray = (start: number = 0, length: number) => {
  const dataArray = []
  for (let i = start; i < length; i++) {
    dataArray.push(i)
  }
  return dataArray
}

export const getColorRGBA = (color: number, alpha: number = 1) => {
  return `rgba(${(color >> 16) & 0xff}, ${(color >> 8) & 0xff}, ${color & 0xff}, ${alpha})`
}
export const hexToRgb = (hex: string): number[] => {
  hex = hex.replace(/^#/, '')
  const bigint = parseInt(hex, 16)
  const r = (bigint >> 16) & 0xff
  const g = (bigint >> 8) & 0xff
  const b = bigint & 0xff

  return [r, g, b]
}

export function adjustFontSize(text: string, textWidth: number, fontSize: number = 10): number {
  textWidth = textWidth - 18 // 16 偏移量
  // let strW = getStringWidth(text, fontSize)
  let strW = defaultTextureWidth.get(text) || 0
  if (strW >= textWidth) {
    let scale = textWidth / strW
    fontSize = fontSize - (1 - scale) * text.length
  }
  return fontSize
}

// 计算字符串宽度
// const getStringWidth = (str: string, fontSize: number): number => {
//   let span = document.createElement('span')
//   span.style.fontSize = fontSize + 'px'
//   span.style.fontWeight = 'bold'
//   span.style.visibility = 'hidden'
//   span.textContent = str
//   document.body.appendChild(span)
//   let textWidth: number = span.offsetWidth
//   document.body.removeChild(span)
//   return textWidth
// }

export function hexToInteger(hex: string): number {
  return parseInt(hex.replace(/^#/, ''), 16)
}

// 将整数值转换为十六进制颜色代码
export function integerToHex(integer: number): string {
  return '#' + integer.toString(16).toUpperCase().padStart(6, '0')
}

export function getDataBeforeUnderscore(inputString: string): string {
  const underscoreIndex = inputString.indexOf('_')
  if (underscoreIndex !== -1) {
    return inputString.substring(0, underscoreIndex)
  } else {
    return inputString
  }
}

// 行程单位数据转换函数
export const convertTravel = (num: number): string => {
  const travel = travelConfig(DeviceManager.instance.state.currentPid)
  const roundedNum = Math.round(num) / travel.unit
  return roundedNum.toFixed(travel.decimalPlaces)
}
export const getStringAfterDash = (input: string): string => {
  if (input == undefined) {
    return ''
  }
  const parts = input.split('-')
  if (parts.length > 1) {
    return parts[1]
  }
  return input
}
export const normalizeKeyCode = (KeyCode: number[], tab: BaseTabs, data: number[] = AssistKeys()): number[] => {
  if (tab && tab != BaseTabs.compose) {
    const key = KeyCode.filter((key) => key > 0)
    if (key.length == 0) {
      return KeyCode
    }
    return [0, 0, key[0]]
  }

  const normalizedKeyCode: number[] = [0, 0, 0]
  for (let i = 0; i < [0, 0].length; i++) {
    const key = KeyCode[i] || 0
    if (data.includes(key) && key > 0) {
      normalizedKeyCode[i] = JSON.parse(JSON.stringify(key))
    }
  }
  const nonAssistKeys = KeyCode.filter((key) => !data.includes(key) && key > 0)
  if (nonAssistKeys.length > 0) {
    normalizedKeyCode[2] = nonAssistKeys[0]
  }
  return normalizedKeyCode
}

export const decimalToHex = (decimal: number): string => {
  const hexString = decimal.toString(16)
  return hexString.padStart(4, '0')
}

export const hexToDecimal = (hex: string): number => {
  return parseInt(hex, 16)
}
const componentToHex = (c: number) => {
  const hex = c.toString(16)
  return hex.length === 1 ? '0' + hex : hex
}

export const rgbToHex = (r: number, g: number, b: number) => {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`
}

export const openExternalLink = (url: string) => {
  if (isElectron()) {
    electronAPI.openExternal(url)
  } else {
    window.open(url, '_blank')
  }
}

export const arraysEqual = (arr1: any[], arr2: any[]): boolean => {
  if (arr1.length !== arr2.length) return false
  const sortedArr1 = arr1.slice().sort() // 使用 slice() 防止修改原数组
  const sortedArr2 = arr2.slice().sort()
  return sortedArr1.every((value, index) => value === sortedArr2[index])
}

export const findValue = (arr: number[], target: number): number => {
  if (arr.length === 0) return target
  return arr.reduce((prev, curr) => {
    return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev
  })
}

export const findIndex = (arr: number[], target: number): number => {
  if (arr.indexOf(target) === -1) {
    return target
  }
  return arr.indexOf(target)
}
export const formatTime = (seconds: number): string => {
  const { t } = i18n.global
  if (seconds < 60) {
    return `${seconds} ${t('second')}`
  } else if (seconds <= 3600) {
    const minutes = seconds / 60
    return `${minutes} ${t('minute')}`
  } else {
    const hours = seconds / 3600
    return `${hours} ${t('hour')}`
  }
}
